/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState } from "react";

/**
 * Hook to detect if code is running on the client side.
 * Returns false during server-side rendering and true after hydration.
 *
 * Useful for preventing hydration mismatches when content differs between
 * server and client (e.g., date formatting, browser-specific features).
 *
 * @see https://nextjs.org/docs/messages/react-hydration-error#solution-1-using-useeffect-to-run-on-the-client-only
 */
export function useIsClient() {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}
